<template>
    <div class="pager">
        <Icon   
            :class="{inactive: firstPage}"
            :svg="doubleArrowIcon"
            class="flipped-y arrow"
            @click.native="setPage(1)" />

        <Icon
            :class="{inactive: firstPage}"
            :svg="arrowIcon"
            class="flipped-y arrow"
            @click.native="setPage(page - 1)" />

        Page: 
        <input 
            ref="pageInput"
            :value="page"
            type="text"
            @input="updateValue($event.target.value)"> 
        of {{ totalPages }}
        
        <Icon
            :class="{inactive: lastPage}" 
            :svg="arrowIcon" 
            class="arrow"
            @click.native="setPage(page + 1)" />

        <Icon
            :class="{inactive: lastPage}"  
            :svg="doubleArrowIcon" 
            class="arrow"
            @click.native="setPage(totalPages)" />
        
        {{ totalResults }} Results
    </div>

</template>

<script>
const debounce = require('lodash/debounce');

import DoubleArrowIcon from 'voluum-frontend-icons/double-arrow.svg';
import ArrowIcon from 'voluum-frontend-icons/arrow.svg';

import Icon from './Icon';

export default {
    name: 'Pager',

    components: {
        Icon
    },
    
    props: {
        page: {
            type: Number,
            default: 1,
            required: true
        },
        totalPages: {
            type: Number,
            default: 1,
            required: true
        },
        totalResults: {
            type: Number, 
            default: 1,
            required: true
        }
    },

    data: function () {
        return {
            doubleArrowIcon: DoubleArrowIcon,
            arrowIcon: ArrowIcon
        };
    },

    computed: {

        firstPage: function () {
            return this.page === 1;
        },

        lastPage: function () {
            return this.page === this.totalPages;
        }
    },

    watch: {
        page: debounce(function (current, previous) {
            const currentPage = parseInt(current, 10);
            const previousPage = parseInt(previous, 10);

            if(currentPage) {
                if(this.isPageInRange(currentPage)) {
                    this.setPage(currentPage);
                }
                else {
                    this.restorePage(previousPage);
                }
            }
            else {
                this.restorePage(previousPage);
            }
            
        }, 200)
    },

    methods: {
        updateValue: function (value) {
            const nextPage = parseInt(value, 10);

            if(this.isPageInRange(nextPage)) {
                this.$emit('input', nextPage);
            }
            else {
                this.$refs.pageInput.value = this.page;
            }
        },

        isPageInRange: function (nextPage) {
            return nextPage > 0 && nextPage <= this.totalPages;
        },

        setPage: function (page) {
            if(this.isPageInRange(page)) {
                this.$store.commit('setPage', page);
                this.$store.dispatch('loadReport');
            }
        },

        restorePage: function (page) {
            this.page = page;
        }
    }
};
</script>

<style lang="less">
    @import "../styles/colors.less";
    
    .pager svg {
        fill: @color-blue;
    }

    .inactive svg {
        fill: @color-grey;
    }
</style>

<style lang="less" scoped>

    @import "../styles/colors.less";
    @import "../styles/globals.less";

    .flipped-y {
        transform: rotateY(180deg);
    }

    .arrow {
        margin: 0 4px;
    }

    .arrow:not(.inactive) {
        cursor: pointer;
    }

    input {
        width: 36px;
        margin: 0 4px;
        text-align: center;
    }

    .pager {
        display: flex;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Pager.vue